// Shared by seed validation, API persistence, SEO and the page. No executable
// markup, arbitrary styles, URLs or animation code are accepted from content.
const VISUAL_TYPES = ['table', 'document', 'checklist', 'timeline', 'presentation', 'code', 'chart'];
const VISUAL_TONES = ['blue', 'violet', 'amber', 'rose'];
const text = value => typeof value === 'string' && value.trim().length > 0 && value.length <= 1800;
const texts = (value, min = 1, max = 8) => Array.isArray(value) && value.length >= min && value.length <= max && value.every(text);
const sections = value => Array.isArray(value) && value.length >= 2 && value.length <= 5 && value.every(item => item && text(item.label) && text(item.text));

function isUseCaseVisual(item) {
  if (!item || item.version !== 1 || !VISUAL_TYPES.includes(item.type) || !VISUAL_TONES.includes(item.tone)
    || !['reveal', 'none'].includes(item.motion) || !text(item.title) || !text(item.promptTitle)
    || !text(item.sourceLabel) || !texts(item.source, 2, 5) || !texts(item.steps, 2, 4)
    || !text(item.takeaway) || !text(item.review) || !text(item.output?.title)) return false;
  const out = item.output;
  if (out.cover && !(item.type === 'presentation' && text(out.cover.title) && text(out.cover.caption) && ['geometric', 'plain'].includes(out.cover.style))) return false;
  if (item.type === 'chart') return Array.isArray(out.metrics) && out.metrics.length >= 2 && out.metrics.length <= 4
    && out.metrics.every(metric => metric && text(metric.label) && text(metric.display) && text(metric.caption)
      && Number.isFinite(metric.max) && metric.max > 0
      && (metric.value === null || Number.isFinite(metric.value) && metric.value >= 0 && metric.value <= metric.max));
  if (item.type === 'table') return texts(out.columns, 2, 4) && Array.isArray(out.rows) && out.rows.length >= 2 && out.rows.length <= 5
    && out.rows.every(row => texts(row, out.columns.length, out.columns.length));
  if (item.type === 'code') return text(out.code) && text(out.caption);
  return sections(out.sections);
}

function getUseCaseVisuals(value) {
  return Array.isArray(value) ? value.filter(isUseCaseVisual).slice(0, 3) : [];
}
module.exports = { VISUAL_TYPES, VISUAL_TONES, isUseCaseVisual, getUseCaseVisuals };
